import { Modal } from "react-bootstrap";
import "./Success_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useEffect } from "react";

const Success_Modal = (props) => {
  useEffect(() => {
    // Automatically hide modal after 3 seconds
    const timer = setTimeout(() => {
      props?.onHide();
    }, 3000);

    // Cleanup timeout when modal unmounts or reopens
    return () => clearTimeout(timer);
  }, [props?.show]);

  return (
    <Modal className="Success_Modal" size="sm" {...props} centered>
      <div className="animation_holder">
        <div
          className="absolute_div"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "20px",
          }}
        >
          <FontAwesomeIcon
            icon={faCircleCheck}
            style={{ color: "#28a745", fontSize: "80px" }}
          />
        </div>
      </div>

      <Modal.Body>
        <p className="success_text">{props?.successText}</p>
      </Modal.Body>
    </Modal>
  );
};

export default Success_Modal;
